var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warn = (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	43171: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/core", [4,17,3,3], () => (Promise.all([__webpack_require__.e(9015), __webpack_require__.e(7167), __webpack_require__.e(7580)]).then(() => (() => (__webpack_require__(37580))))))),
	49439: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/animations", [4,17,3,3], () => (Promise.all([__webpack_require__.e(6077), __webpack_require__.e(7172)]).then(() => (() => (__webpack_require__(47172))))))),
	16077: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/common", [4,17,3,3], () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(60316))))))),
	9015: () => (loadStrictSingletonVersionCheckFallback("default", "rxjs", [2,7,8,1], () => (Promise.all([__webpack_require__.e(7141), __webpack_require__.e(1340)]).then(() => (() => (__webpack_require__(31340))))))),
	57167: () => (loadStrictSingletonVersionCheckFallback("default", "rxjs/operators", [2,7,8,1], () => (Promise.all([__webpack_require__.e(7141), __webpack_require__.e(3620)]).then(() => (() => (__webpack_require__(23620))))))),
	77141: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/keycodes", [4,17,3,3], () => (__webpack_require__.e(4879).then(() => (() => (__webpack_require__(74879))))))),
	61273: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/platform", [4,17,3,3], () => (Promise.all([__webpack_require__.e(6077), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(17699))))))),
	1115: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/coercion", [4,17,3,3], () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(2814))))))),
	72297: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/observers", [4,17,3,3], () => (Promise.all([__webpack_require__.e(1115), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(39539))))))),
	41719: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/layout", [4,17,3,3], () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(87912))))))),
	14729: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/collections", [4,17,3,3], () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(37989))))))),
	80079: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/a11y", [4,17,3,3], () => (Promise.all([__webpack_require__.e(9522), __webpack_require__.e(1273), __webpack_require__.e(1115), __webpack_require__.e(2297), __webpack_require__.e(2102)]).then(() => (() => (__webpack_require__(72102))))))),
	94483: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/bidi", [4,17,3,3], () => (Promise.all([__webpack_require__.e(6077), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(63680))))))),
	32067: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/portal", [4,17,3,3], () => (__webpack_require__.e(9168).then(() => (() => (__webpack_require__(9168))))))),
	3957: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/overlay", [4,17,3,3], () => (Promise.all([__webpack_require__.e(1273), __webpack_require__.e(4483), __webpack_require__.e(1115), __webpack_require__.e(6273), __webpack_require__.e(1570)]).then(() => (() => (__webpack_require__(81570))))))),
	96273: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/scrolling", [4,17,3,3], () => (Promise.all([__webpack_require__.e(1115), __webpack_require__.e(4729), __webpack_require__.e(9975)]).then(() => (() => (__webpack_require__(79975))))))),
	64659: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/core/primitives/signals", [4,17,3,3], () => (__webpack_require__.e(5689).then(() => (() => (__webpack_require__(85689))))))),
	37195: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/core", [4,17,3,3], () => (Promise.all([__webpack_require__.e(6077), __webpack_require__.e(7167), __webpack_require__.e(9522), __webpack_require__.e(79), __webpack_require__.e(1273), __webpack_require__.e(4483), __webpack_require__.e(1115), __webpack_require__.e(4646)]).then(() => (() => (__webpack_require__(74646))))))),
	51951: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/forms", [4,17,3,3], () => (Promise.all([__webpack_require__.e(6077), __webpack_require__.e(7167), __webpack_require__.e(4456)]).then(() => (() => (__webpack_require__(34456))))))),
	62119: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/form-field", [4,17,3,3], () => (Promise.all([__webpack_require__.e(1273), __webpack_require__.e(4483), __webpack_require__.e(1115), __webpack_require__.e(9439), __webpack_require__.e(2297), __webpack_require__.e(2569)]).then(() => (() => (__webpack_require__(24950))))))),
	84386: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk", [4,17,3,3], () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(31398))))))),
	34411: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/dialog", [4,17,3,3], () => (Promise.all([__webpack_require__.e(1273), __webpack_require__.e(4483), __webpack_require__.e(3482)]).then(() => (() => (__webpack_require__(93482))))))),
	53937: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/accordion", [4,17,3,3], () => (Promise.all([__webpack_require__.e(4729), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(9180))))))),
	38729: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/observers/private", [4,17,3,3], () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(98615))))))),
	78707: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/common/http", [4,17,3,3], () => (Promise.all([__webpack_require__.e(9015), __webpack_require__.e(7167), __webpack_require__.e(6443)]).then(() => (() => (__webpack_require__(46443))))))),
	38166: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/platform-browser", [4,17,3,3], () => (Promise.all([__webpack_require__.e(8707), __webpack_require__.e(436)]).then(() => (() => (__webpack_require__(80436))))))),
	90235: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/animations/browser", [4,17,3,3], () => (Promise.all([__webpack_require__.e(9439), __webpack_require__.e(655)]).then(() => (() => (__webpack_require__(10655))))))),
	49863: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/core/rxjs-interop", [4,17,3,3], () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(49074))))))),
	80589: () => (loadStrictSingletonVersionCheckFallback("default", "ag-grid-community", [1,30,2,0], () => (__webpack_require__.e(3768).then(() => (() => (__webpack_require__(53768))))))),
	44680: () => (loadStrictSingletonVersionCheckFallback("default", "rete", [4,2,0,2], () => (__webpack_require__.e(4472).then(() => (() => (__webpack_require__(74472))))))),
	17412: () => (loadStrictSingletonVersionCheckFallback("default", "rete-area-plugin", [4,2,0,0], () => (Promise.all([__webpack_require__.e(4680), __webpack_require__.e(9388)]).then(() => (() => (__webpack_require__(89388))))))),
	41885: () => (loadStrictSingletonVersionCheckFallback("default", "tslib", [1,2,6,2], () => (__webpack_require__.e(4398).then(() => (() => (__webpack_require__(24398)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"79": [
		80079
	],
	"235": [
		90235
	],
	"589": [
		80589
	],
	"1115": [
		1115
	],
	"1273": [
		61273
	],
	"1951": [
		51951
	],
	"2067": [
		32067
	],
	"2102": [
		41719
	],
	"2119": [
		62119
	],
	"2297": [
		72297
	],
	"2569": [
		38729
	],
	"2587": [
		34411
	],
	"3171": [
		43171
	],
	"3937": [
		53937
	],
	"3957": [
		3957
	],
	"4483": [
		94483
	],
	"4646": [
		84386
	],
	"4680": [
		44680
	],
	"4729": [
		14729
	],
	"6077": [
		16077
	],
	"6273": [
		96273
	],
	"7141": [
		41885
	],
	"7167": [
		57167
	],
	"7195": [
		37195
	],
	"7412": [
		17412
	],
	"7580": [
		64659
	],
	"8166": [
		38166
	],
	"8707": [
		78707
	],
	"9015": [
		9015
	],
	"9439": [
		49439
	],
	"9522": [
		77141
	],
	"9863": [
		49863
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}